import {Route} from '@config/routes';
import {FetchException} from '@core/exceptions';
import {AuthService} from '@services/auth/auth.service';
import {getLocale} from '@utils/getLocale';
import {getPrependLocale} from '@utils/prependLocale';
import {redirect} from 'next/navigation';
import {requestFetch} from './http';
import {IFetchParams, IFetchResponse} from './http.model';
import {addMethodsToFetch, checkIsSessionError} from './http.util';

const requestFetchAuth = async <T>(
    url: string,
    params: IFetchParams,
): Promise<IFetchResponse<T>> => {
    try {
        await tryAddAuthHeader(params);
        return await requestFetch(url, params);
    } catch (error) {
        const locale = await getLocale();
        const logoutRouteLocalized = getPrependLocale(Route.LOGOUT, locale);
        if (checkIsSessionError(error as FetchException)) {
            redirect(logoutRouteLocalized);
        }
        throw error;
    }
};

export const httpAuth = addMethodsToFetch(requestFetchAuth);

const tryAddAuthHeader = async (params: RequestInit) => {
    const isTokenValid = await AuthService.isTokenValid();
    const refreshToken = await AuthService.fetchRefreshToken();

    if (!isTokenValid && refreshToken) {
        await AuthService.refreshSession();
    }
    const bearerToken = await AuthService.getToken();
    params.headers = {
        ...params.headers,
        Authorization: 'Bearer ' + bearerToken,
    };
};
